import { useEffect, useMemo, useState } from "react";

import { useWindowSize } from "@/hooks/useIsMobile";

const MPLiveTV = ({ electionLiveData = "", firstActive = "" }) => {
  const [selectedVideo, setSelectedVideo] = useState(firstActive);
  const [liveStreamData, setLiveStreamData] = useState(null);

  const [activeTab, setActiveTab] = useState(0);

  const liveKeys = useMemo(() => {
    let temp = [];
    Object?.keys(electionLiveData).forEach((key) => {
      if (electionLiveData[key]?.status === "1") {
        temp.push(key);
      }
    });
    return temp;
  }, [electionLiveData]);

  // Merge liveKeys with the liveStreamData event title
  const tabs = liveStreamData
    ? [...liveKeys, liveStreamData?.event_title]
    : liveKeys;
  const size = useWindowSize();
  useEffect(() => {
    if (!selectedVideo && tabs?.length > 0) {
      setSelectedVideo(tabs[0]); // Default to the first available tab
      setActiveTab(0); // Set the first tab as active
    }
  }, [tabs, selectedVideo]);

  return (
    <div className="mx-0 my-2 w-auto h-auto md:mx-[30px] md:my-4 overflow-hidden  ">
      {selectedVideo && electionLiveData?.[selectedVideo]?.livetv_code && (
        <div className="  ">
          <div
            className={
              size.width > 768 ? " " : `custom-iframe aspect-w-16 aspect-h-9 `
            }
            dangerouslySetInnerHTML={{
              __html: `${electionLiveData?.[selectedVideo]?.livetv_code}`,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default MPLiveTV;
